import { Divider } from "antd";
import React, { useEffect, useState } from "react";

import Senditem from "./senditem";

const ShowData = (props: {
  form: { type: string; year: string; term: string };
  curri: {
    id: number;
    level: string;
    degreeName: string;
    name: string;
    shortName: string;
  }[];
}) => {
  const { form, curri } = props;
  const [typeDoc, setTypeDoc] = useState("");
  const [lavelList, setLavelList] = useState<string[]>([]);
  useEffect(() => {
    (async () => {
      switch (form.type) {
        case "mhesi3":
          setTypeDoc("อชว.3-4");
          setLavelList(["ปวช.", "ปวส."]);
          break;
        case "mhesi5":
          setTypeDoc("อชว.5-6");
          setLavelList(["ปวช.", "ปวส."]);
          break;
        case "tqf3":
          setTypeDoc("มคอ.3-4");
          setLavelList(["ป.ตรี", "ป.โท"]);
          break;
        case "tqf5":
          setTypeDoc("มคอ.5-6");
          setLavelList(["ป.ตรี", "ป.โท"]);
          break;

        default:
          setLavelList([]);
          setTypeDoc("");
          break;
      }
    })();
  }, [form.type]);

  return (
    <>
      <div className="row text-start">
        <h4>
          รายละเอียดการส่งเอกสารแบบสรุป {typeDoc} ประจำภาคการศึกษาที่{" "}
          {form.term}/{form.year}
        </h4>
      </div>
      <div className="row">
        <table className="table table-hover table-responsive">
          <thead className="table-dark">
            <tr>
              <th style={{ width: "60%" }}>หลักสูตร</th>
              <th>วันที่ส่งเอกสาร</th>
              <th style={{ width: "20%" }}>Handle</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>

      <Divider orientation="left">
        <h4>ระดับ {lavelList[0]}</h4>
      </Divider>
      <table className="table table-hover table-responsive">
        <tbody>
          {curri
            .filter((x) => x.level === lavelList[0])
            .map((curri) => {
              return <Senditem curri={curri} form={form} typeDocTH={typeDoc} />;
            })}
        </tbody>
      </table>
      <br />
      <Divider orientation="left">
        <h4>ระดับ {lavelList[1]}</h4>
      </Divider>
      <table className="table table-hover table-responsive">
        <tbody>
          {curri
            .filter((x) => x.level === lavelList[1])
            .map((curri) => {
              return <Senditem curri={curri} form={form} typeDocTH={typeDoc} />;
            })}
        </tbody>
      </table>
    </>
  );
};

export default ShowData;
